<template>
    <v-dialog
        v-model="show"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        :hide-overlay="$vuetify.breakpoint.smAndDown"
        :max-width="500"
        :transition="$vuetify.breakpoint.smAndDown
            ? 'dialog-bottom-transition'
            : 'fade-transition'"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon>
                    edit
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <!-- Toolbar -->
            <v-toolbar
                dark
                color="primary"
            >
                <v-btn
                    icon
                    dark
                    @click="show = false"
                    :disabled="isSaving"
                >
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    Edit Bio
                </v-toolbar-title>
                <v-spacer />
                <v-toolbar-items
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-btn
                        dark
                        text
                        :loading="isSaving"
                        :disabled="isSaving"
                        @click="onSubmit"
                    >
                        Save
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <!-- Form -->
            <v-card-text>
                <v-form
                    ref="form"
                    class="my-3"
                    @submit.prevent="onSubmit"
                >
                    <v-text-field
                        label="Name"
                        v-model="profileName"
                        color="secondary"
                    />

                    <v-textarea
                        label="Description"
                        v-model="description"
                        auto-grow
                        counter="1024"
                        :rules="[
                            rules.maxLength
                        ]"
                        color="secondary"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions
                v-if="$vuetify.breakpoint.mdAndUp"
            >
                <v-spacer />
                <v-btn
                    text
                    @click="show = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    @click="onSubmit"
                    color="primary"
                    :loading="isSaving"
                    :disabled="isSaving"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import MessageBus from '../../utils/buses/MessageBus'
import { defaultError, default422Error } from '../../utils/constants/errors'

export default {
    data () {
        return {
            show: false,
            profileName: null,
            description: null,
            isSaving: false,
            rules: {
                maxLength: val => !val || (val && val.length <= 1024) || 'Description must be 1024 characters or less'
            }
        }
    },

    props: {
        bio: {
            type: Object,
            default: () => ({
                profileName: null,
                description: null
            })
        }
    },

    watch: {
        bio: {
            immediate: true,
            handler: function (val) {
                this.profileName = val.profileName
                this.description = val.description
            }
        }
    },

    methods: {
        onSubmit () {
            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                return
            }

            this.isSaving = true

            axios.put('/user', {
                profileName: this.profileName,
                description: this.description
            })
                .then(res => {
                    MessageBus.sendMessage('Bio updated successfully', 'success')
                    this.show = false
                    this.$emit('save', {
                        profileName: this.profileName,
                        description: this.description
                    })
                })
                .catch(err => {
                    console.error('Edit Bio Error', err)
                    MessageBus.sendMessage(defaultError, 'error')
                })
                .finally(() => {
                    this.isSaving = false
                })
        }
    }
}
</script>
